import React from 'react';
import LockIcon from '@material-ui/icons/Lock';

import { buildAnchorCheckoutLink } from '../../../../utils/helpers';


export const LockIconContainer = ({ isLocked }) => {
  if (!isLocked) {
    return null;
  }

  return (
    <div className="private-video-lock-icon">
      <LockIcon />
    </div>
  );
};

export const PriceForClipStoreItem = ({ payPerViewNav, price }) => {
  const shouldShowPrice = payPerViewNav === 'New' && price > 0;
  if (!shouldShowPrice) {
    return null;
  }

  return (
    <>
      <div className="private-video-price private-gallery-price">
        ${price}
      </div>
      <div className="private-video-buy-now-cta private-gallery-buy-now-cta">
        Buy Now!
      </div>
    </>
  );
};

export const linkToPaymentPage = (isSubscribed, anchorId, anchorShortUrl) => {
  if (isSubscribed) {
    return '#';
  }

  return buildAnchorCheckoutLink(anchorId, anchorShortUrl);
};


